import React from 'react';
import { FireOutlined } from '@ant-design/icons';

const HotList = ({ items = [], title = "热点榜", className = "", onItemClick }) => {
  return (
    <div className={`w-[328px] h-[732px] bg-[#333333] rounded-[20px] p-4 ${className}`}>
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-white text-base font-bold">热点榜</h3>
      </div>

      <div className="flex flex-col gap-3">
        {items.map((item, index) => (
          <div 
            key={item.id || index} 
            className="flex items-center gap-3 cursor-pointer group"
            onClick={() => onItemClick && onItemClick(item)}
          >
            <div className={`text-sm font-bold w-4 text-center ${
              index < 3 ? 'text-[#FF4D4F] italic' : 'text-gray-400'
            }`}>
              {index + 1}
            </div>
            <div className="flex-1 text-sm text-gray-300 group-hover:text-white truncate transition-colors">
              {item.title}
            </div>
            {(item.hotValue !== undefined && item.hotValue !== null) && (
              <div className="text-xs text-gray-500">
                #{item.hotValue}
              </div>
            )}
            {item.tag && (
               <div className={`text-[10px] px-1 rounded border ${
                 item.tag === '新' ? 'text-red-400 border-red-900 bg-red-900/20' : 
                 item.tag === '热' ? 'text-orange-400 border-orange-900 bg-orange-900/20' :
                 'text-gray-400 border-gray-700'
               }`}>
                 {item.tag}
               </div>
            )}
          </div>
        ))}
        
        {items.length === 0 && (
          <div className="text-center text-gray-500 text-xs py-4">暂无热点数据</div>
        )}
      </div>
    </div>
  );
};

export default HotList;
